import type {FC} from 'react'
import {Paper, Stack, SvgIcon, Typography, useTheme} from '@mui/material'
import TerrainIcon from '@mui/icons-material/Terrain'

import {
  livePulseSx,
  liveStatusSx,
} from '@containers/Dashboards/AgentChat/components/messages/liveStatusSx'

/**
 * The agent's side of a turn that is deliberately paused (AB#5992).
 *
 * While a turn waits for an attachment to finish being indexed there is nothing
 * to stream, so the agent's place in the thread was a bare pulsing icon and the
 * pause read as a hang. The file's own card says which file is being read; this
 * says what the turn is doing about it.
 *
 * Wears the tool line's frame, from the same module, because it is the same
 * "agent, still working" state — not a ToolBubble, which takes a tool summary,
 * and no tool has run.
 */
const WaitingBubble: FC<{text: string; tone?: 'default' | 'incident'}> = ({
  text,
  tone = 'default',
}) => {
  const theme = useTheme()

  return (
    <Paper sx={liveStatusSx(theme, tone, true)}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <SvgIcon component={TerrainIcon} fontSize="small" sx={livePulseSx} />
        <Typography variant="body2" color="text.secondary">
          {text}
        </Typography>
      </Stack>
    </Paper>
  )
}

export default WaitingBubble
